import React, { useCallback } from "react";

import { useParams } from "react-router-dom";

import AccountPlanContainer from "../../Container/AccountPlanContainer";

/** /account-plan/:accountId — plan links + versions, slide viewer, Sponsor View. */
const AccountPlan: React.FC = () => {
  const { accountId, orgSlug } = useParams<{
    accountId: string;
    orgSlug?: string;
  }>();
  const withOrg = useCallback(
    (path: string) =>
      orgSlug ? `/${orgSlug}${path.startsWith("/") ? path : `/${path}`}` : path,
    [orgSlug]
  );
  if (!accountId) return null;
  return (
    <AccountPlanContainer
      key={accountId}
      accountId={accountId}
      withOrg={withOrg}
    />
  );
};

export default AccountPlan;
